export default "__VITE_ASSET__CQn_8AbP__"